let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hjDJb")).then(() => parcelRequire('hM1vX'));